import React, { useState, useEffect } from "react";
import styled from "styled-components";
import TextNumber from "../based/inputs/TextNumber";
import CommonModal from "../based/refactor/CommonModal";
import Request from "../based/Request";
import { Notify } from "../based/Notify";
import { CONSTANTS, NOTIFY } from "../based/Constants";
import OrderServices from "../based/services/OrderServices";

function PayAlreadyModal({ show, onClose, onSave, orderId }) {
    const [transferPartial, setTransferPartial] = useState(0);
    const [fileUrl, setFileUrl] = useState("");
    const [busy, setBusy] = useState(false);
    const [note, setNote] = useState("");

    const handleSave = async (model) => {
        let [err, data] = await OrderServices.UpdateTranscriptStatus(model);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Cập nhật thành công");
            onSave();
        } else {
            let errMsg =
                err.errors && err.errors.length > 0
                    ? err.errors.reduce((prev, item, idx) => {
                          return `${prev}${item.value}<br/>`;
                      }, "")
                    : "" || CONSTANTS.MSG_ERROR;
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, errMsg);
        }
    };

    const handleChangeImage = (e) => {
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file) {
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                Request.UploadImage(file).then((res) => {
                    if (res && res.data) {
                        setFileUrl(res.data.imageUrl);
                    } else {
                        let errMsg =
                            res.errors && res.errors.length > 0
                                ? res.errors.reduce((prev, item, idx) => {
                                      return `${prev}${item.value}<br/>`;
                                  }, "")
                                : "" || CONSTANTS.MSG_ERROR;
                        Notify(NOTIFY.ERROR, NOTIFY.ERROR, errMsg);
                    }
                });
            };
        }
    };

    return (
        <CommonModal
            show={show}
            onClose={onClose}
            title="Khách đã thanh toán"
            onConfirm={() => {
                handleSave({ orderId: orderId, transferPartial: transferPartial, transcriptUrl: fileUrl, note: note });
            }}
            isBusy={busy}
        >
            <Wrapper>
                <div className="body-modal">
                    <div className="form-group">
                        <label htmlFor="money" className="required">
                            Nhập số tiền khách đã cọc/thanh toán
                        </label>
                        <TextNumber
                            suffix="Đồng"
                            placeholder="Số tiền"
                            name="money"
                            className="form-control"
                            value={transferPartial}
                            onChanged={(name, value) => {
                                setTransferPartial(value);
                            }}
                        />
                    </div>
                    <div className="list-btn-money">
                        <div className="btn-money" onClick={() => setTransferPartial(50000)}>
                            50K
                        </div>
                        <div className="btn-money" onClick={() => setTransferPartial(100000)}>
                            100K
                        </div>
                        <div className="btn-money" onClick={() => setTransferPartial(150000)}>
                            150K
                        </div>
                        <div className="btn-money" onClick={() => setTransferPartial(200000)}>
                            200K
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Ghi chú</label>
                        <textarea className="form-control" rows="3" placeholder="Ghi chú" value={note} onChange={(e) => setNote(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="note" className="required">
                            Hình chụp thanh toán thành công
                        </label>
                        {fileUrl ? (
                            <div className="preview-img cursor-pointer" onClick={() => document.getElementById("uploadImage").click()}>
                                <img src={fileUrl} alt="Preview" />
                            </div>
                        ) : (
                            <div className="upload-img cursor-pointer" onClick={() => document.getElementById("uploadImage").click()}>
                                <span>
                                    <i className="fa fa-plus"></i>
                                    Chọn hình
                                </span>
                            </div>
                        )}
                        <input type="file" onChange={handleChangeImage} className="d-none" accept="image/*" id="uploadImage" />
                    </div>
                    <div className="form-group">
                        <div className="instruction">
                            <b>Lưu ý:</b> Khi điền "Khách đã thanh toán", hệ thống sẽ trừ phần COD khỏi đơn và không cộng vào kỳ tất toán. Vui lòng kiểm tra cẩn thận trước khi xác nhận.
                        </div>
                    </div>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default PayAlreadyModal;

const Wrapper = styled.div`
    textarea.form-control {
        border-radius: 8px !important;
        border: 1px solid #e5e5e5;
        background: #fff;
    }

    .preview-img {
        width: 74px;
        height: 74px;
        background: #e5e5e5;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
    }

    .preview-img img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .input-group {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
    }

    .input-group-append {
        /* background: none; */
    }

    span.input-group-text {
        background: none;
        border: none;
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .input-group .form-control {
        border: none;
    }

    .list-btn-money {
        display: flex;
        flex-wrap: wrap;
    }

    .btn-money {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        margin: 8px 16px 8px 0;
        padding: 10px;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        cursor: pointer;
    }

    .upload-img {
        display: flex;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        width: 74px;
        height: 74px;
        justify-content: center;
    }

    .upload-img span {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .form-group {
        margin: 12px 0;
    }

    .instruction {
        border-radius: 8px;
        background: #fff5ec;
        padding: 10px;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
`;
